import { memo } from 'react';
import { PrizeWallImageProps } from './PrizeWallImage.types';
import { Breakpoint, Image, useBreakpoint } from '@bonanza-social/moonlight';

function PrizeWallImage({
  mobileUrl,
  desktopUrl,
  ...rest
}: PrizeWallImageProps) {
  const breakpoint = useBreakpoint();
  const source = breakpoint === Breakpoint.MOBILE ? mobileUrl : desktopUrl;

  return source && <Image source={source} {...rest} />;
}

export default memo(PrizeWallImage);
